import { createSelector } from 'reselect';
import { getCurrentScreenSize } from 'ha/modules/UI/selectors';
import { boxAspectRatio as PreviewImageRatio } from 'ha/components/Listing/constants';
import { PreviewImageHeight } from '../constants';

export function getPreviewImagesSize(screenSize) {
  const height = PreviewImageHeight[screenSize];

  if (!height) return null;

  return `${(height * PreviewImageRatio).toFixed(0)}x${height}`;
}

export default createSelector(
  [getCurrentScreenSize],
  getPreviewImagesSize,
);
